import { Col, Row } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import List from './ItemList/List';

function ListVariants({
  values,
  setFieldValue,
  addItem,
  deleteVariant,
  deleteItem,
  errors,
}) {
  const { t } = useTranslation();
  const [isDragging, setisDraggig] = useState(false);
  const [editVariant, setEditVariant] = useState([]);
  const [variantBelongin, setvariantBelongin] = useState([]);

  const dragItem = React.useRef(null);
  const dragOverItem = React.useRef(null);

  return (
    <>
      <Row
        style={{
          background: '#F9F9F9',
          height: '47px',
          display: 'flex',
          alignItems: 'center',
          minWidth: '720px',
        }}
      >
        <Col span={1} style={{}} />
        <Col span={1} style={{}} />
        <Col span={10} style={{}}>
          {t('components.InventoryVariants.ListVariants.variantName')}
        </Col>
        <Col span={10} style={{}}>
          {t('components.InventoryVariants.ListVariants.length')}
        </Col>
        <Col span={2} style={{}} />
      </Row>

      <div>
        {values?.variants.map((variant, indexVariants) => (
          <List
            key={indexVariants}
            variant={variant}
            setFieldValue={setFieldValue}
            values={values}
            indexVariants={indexVariants}
            deleteVariant={deleteVariant}
            addItem={addItem}
            deleteItem={deleteItem}
            errors={errors}
            dragItem={dragItem}
            dragOverItem={dragOverItem}
            setisDraggig={setisDraggig}
            isDragging={isDragging}
            setEditVariant={setEditVariant}
            editVariant={editVariant}
            variantBelongin={variantBelongin}
            setvariantBelongin={setvariantBelongin}
          />
        ))}
      </div>
    </>
  );
}

export default ListVariants;
